export const FETCH_LOCALE_REQUEST = "fetch/locale/request";
export const FETCH_LOCALE_SUCCESS = "fetch/locale/success";
export const FETCH_LOCALE_FAILURE = "fetch/locale/failure";
